var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.path === '/manage-profile')?_c('manage-profile'):_c('data-arc',{attrs:{"saved-search":_vm.savedSearch,"sampleFilter":_vm.sampleFilter},on:{"login":function($event){return _vm.$emit('login')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }